import React from "react";
import { Card } from "@mui/material";

import DashUnits from "./components/DashUnits";

function DashUnitstatus() {
  return (
    <Card sx={{ backgroundColor: "green" }}>
      <DashUnits />
    </Card>
  );
}

export default DashUnitstatus;
